module.exports = __webpack_public_path__ + "img/General_Event_Icon-2.f5bfa4c0.png";